var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCasino(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8997 6.47613C13.1034 4.2824 10.538 1.4578 9.47413 0.236178C9.19989 -0.0787259 8.71102 -0.0787259 8.43679 0.236178C7.37292 1.45776 4.80753 4.28236 2.01122 6.47613C0.742492 7.47147 0 8.96813 0 10.5539C0 13.3684 2.34487 15.65 5.23741 15.65C6.21568 15.65 7.10554 15.2821 7.76937 14.6811V15.6749C7.76937 16.8846 6.90237 17.0346 6.22965 17.5995C6.06785 17.7354 6.1672 18 6.37846 18H11.5147C11.7252 18 11.8246 17.7372 11.6646 17.6004C10.9988 17.0313 10.1415 16.9043 10.1415 15.6838V14.6811C10.8053 15.2821 11.6952 15.6499 12.6734 15.6499C15.566 15.6499 17.9108 13.3683 17.9108 10.5539C17.9109 8.96813 17.1684 7.47147 15.8997 6.47613Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasino);
export default __webpack_public_path__ + "static/media/casino.2eedc3930415cebfe020fc4b824d55ba.svg";
export { ForwardRef as ReactComponent };